export const OPEN_SOURCE = '/open-source'
